var ranScripts={};
class ExternFooter extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let footerUrl = this.getAttribute('src');
    fetch(footerUrl)
      .then(response => response.text())
      .then(text => {
        let temp_DOM_container = document.createElement('div');
        temp_DOM_container.insertAdjacentHTML('afterbegin',text);
        this.replaceWith(temp_DOM_container.firstElementChild);
      });
  }

}

module.exports.define_footer_element = () => {
    customElements.define('extern-footer', ExternFooter);
}